import useNavigationStore from '@src/stores/navigationStore';
import useRegistrationStore from '@src/stores/registrationStore';

import BlockTitle from '@src/components/_shared/UI/BlockTitle';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import BackButton from '@src/components/_shared/BackButton';
import Container from '@src/components/_shared/Container';
import DropdownList from '@src/components/_shared/UI/DropdownList';
import { useQuery } from '@tanstack/react-query';
import { getReferencialData } from '@src/api/Referencial';
import Loader from '@src/components/_shared/UI/Loader';

export default function Partner() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();

    const cgpId = new URLSearchParams(window.location.search).get("company");

    const _onGoBack = () => {
        setSection(0)
        setBlock('BeforeStart')
    };

    const { data, isLoading, isError } = useQuery({
        queryKey: [`getPartnersData`],
        queryFn: () => getReferencialData({ type: `partner/brand/${registration.partner_informations.brand.code}` }),
    })

    const _handleSelectManager = (value: string) => {
        setField('partner_informations.cgp_id', value)
    }

    const _onValidate = () => {
        setBlock('EmailCheck');
    }

    if (isLoading) {
        return (
            <Container>
                <Loader type="SPINNER" />
            </Container>
        );
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Saisie interne" />
            <div style={{width: '100%'}}>
                <DropdownList
                    title="Marque"
                    width="100%"
                    options={{[`${registration.partner_informations.brand.code}`]: registration.partner_informations.brand.name}}
                    selected={registration.partner_informations.brand.code}
                    onSelect={() => {}}
                    disabled
                />
                <DropdownList
                    title="Gestionnaire"
                    width="100%"
                    options={data}
                    selected={registration.partner_informations.cgp_id}
                    onSelect={_handleSelectManager}
                    disabled={!!cgpId || isError}
                    hasError={isError}
                    placeholder={isError ? 'Aucun gestionnaire' : 'Choisissez'}
                />
            </div>
            <ValidateButton title="Continuer" disabled={!registration.partner_informations.brand.code || !registration.partner_informations.cgp_id} onClick={_onValidate} />
        </Container>
    );
}
